<template>
    <div class="ekstra">
      <!-- <p>Ekstras: {{ this.$store.getters.ekstras }}</p> -->
      <!-- <p>antal senge: {{ this.antal_senge }}</p> -->
      <!-- <p>antal naetter: {{ this.antal_naetter }}</p> -->
      <!-- <p>antal naetter select: {{ this.antal_naetter_select }}</p> -->
      <!-- <p>antal dage: {{ this.antalDage }}</p> -->
      <!-- <p>antal personer: {{ this.antal_personer }}</p> -->
      <!-- <p>antal addons: {{ this.findTotalAddons(this.$store.getters.ekstras, wants, startdate) }}</p> -->
      <!-- <p>Antal checked: {{ this.totalNoChecked }}</p> -->
      <!-- <p>DetailedEkstras: {{ this.detailedEkstras }}</p> -->

      <div v-for="ekstra in this.$store.getters.ekstras" v-bind:key="ekstra.id_rec" class="flex-container">
        <!-- Ny mere detaljeret ekstra-tilkøbs vælger -->
        <div class="roomBoxNew" :class='ekstra.ikon' v-if="handleKarens(ekstra.karens, startdate) && ekstra.mode === 'detaljeret' && !isExcluded(ekstra.ekskluder, wants)">
          <p class="heading">{{ ekstra.overskrift }}</p>
          <p class="descText">{{ekstra.tekst}}</p>
          <p v-if="totalPrice(ekstra.id_rec) > 0" class="priceTextMorgenmad" style="padding-bottom: 20px;">{{ $t('pris') }}: {{ totalPrice(ekstra.id_rec) }}</p>
          <p v-else class="priceTextMorgenmad" style="visibility: hidden; padding-bottom: 20px;">&nbsp;</p>

          <!-- <p>wants: {{ wants }}</p> -->
          <!-- <p>uniqueWants: {{ uniqueWants }}</p> -->

            <!-- <div v-for="roomWants in wants" v-bind:key="roomWants"> -->
            <div v-for="roomWants in uniqueWants" v-bind:key="roomWants">
            <!-- <p>ekstra id_rec: {{ ekstra.id_rec }} roomWants: {{ roomWants }}  DetailedEkstras: {{ detailedEkstras[ekstra.id_rec] }}</p> -->
              <div v-for="(detailed, key, i) in detailedEkstras[ekstra.id_rec]" v-bind:key="i">
                <!-- Vis kun noget hvis det er en detailed ekstra, og indholdet gælder for 'room', og det ikke er sat til ekskluderet -->
                <div v-if="detailed && detailed.room && detailed.room.id_room == roomWants">
                  <div class="ekstraDetailedBox">
                    <!-- <p>Detailed: {{ detailed }}</p> -->
                    <!-- <p>Ekskluder: {{ ekstra.ekskluder }}</p> -->
                    <!-- <p>Editmode: {{ editMode[ekstra.id_rec][room] }}</p> -->
                    <!-- <p>Valgte dage: {{ detailedEkstrasOriginal[ekstra.id_rec][room].days }}</p> -->
                    <!-- <p v-if=" ekstra.ekskluder.split(',').includes(room) ">Dette værelse er ekskluderet</p> -->
                    <!-- <p>Detailed pris: {{ detailed.pris }}</p> -->
                    <!-- <p>Detailed antal personer: {{ detailed.antal_personer }}</p> -->
                    <!-- <p>Detailed antal nætter: {{ detailed.antal_naetter }}</p> -->
                    <!-- <p>maxTotal: {{ ekstra.maxTotal }}</p> -->
                    <!-- <p>Checked: {{ detailed.checked }}</p> -->
                    <!-- <p>Total PRice: {{ totalPrice(ekstra.id_rec) }} id_rec {{ ekstra.id_rec }}</p> -->
                    
                    <p v-if="detailed">{{$t('vaerelse')}}: {{ roomWants }}</p>
                    <div class="ekstraDetailedName">
                      <input type="checkbox" v-model="detailed.checked" @change="modifyDetailedEkstra(detailedEkstras, ekstra.id_rec, detailed.room, detailed.antal_personer, startdate, enddate)"><label for="morgenmad">{{ ekstra.overskrift }}</label>
                    </div>
                    <div class="ekstraDetailedDetails">
                      <p class="ekstraDetailedDetailsPrice">DKK {{ detailed.pris*(detailed.antal_personer * detailed.antal_naetter) }}</p>
                      
                      <!-- vis antal gæster i antal nætter, standard-mode -->
                      <div v-if="editMode[ekstra.id_rec][roomWants] == false">
                        <p>{{ detailed.antal_personer }} {{ ekstra.overskrift }}, {{detailed.antal_naetter}} {{ $t('naetter') }}
                        <span v-if="ekstra.maxTotal == 0" v-on:click="$set(editMode[ekstra.id_rec], roomWants, true)" style="cursor: pointer; text-decoration: underline;">({{ $t('ret') }})</span></p>
                      </div>

                      <!-- vis edit-mode, så der kan vælges antal/nætter -->
                      <div v-if="editMode[ekstra.id_rec][roomWants] == true">
                                                
                          <!-- Antal personer -->
                          <select v-model="detailed.antal_personer">
                            <option v-for="n in detailedEkstras[ekstra.id_rec][roomWants].antal_personer_max" v-bind:key="n">{{ n }}</option>
                          </select> 

                          <span v-if="detailed.antal_personer == 1">{{ $t('person') }}</span><span v-else>{{ $t('personer') }}</span>,

                          <!-- Antal nætter -->
                          <div v-for="day in detailedEkstras[ekstra.id_rec][roomWants].days" v-bind:key="day.date">
                            <input v-model="day.checked" type="checkbox" id="dateEdit" @change="handleAntalNaetterChange(ekstra.id_rec, roomWants); handleDetailedEkstrasChange(detailedEkstras)"><label for="dateEdit">{{ day.date }}</label>
                          </div>

                          <span v-on:click="$set(editMode[ekstra.id_rec], roomWants, false)" style="cursor: pointer; text-decoration: underline; line-height: 12px;">{{ $t('faerdig') }}</span>
                      </div> <!-- end edit-mode -->
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- end for hvert room -->
        </div> <!-- end detailed-ekstra-tilkøb -->

        <!-- <div v-else>
          <p>
            Ikke vist: {{ ekstra }} <br /><br />
            karens skal være true: {{ handleKarens(ekstra.karens, startdate) }}<br />
            mode skal være 'detaljeret': {{ ekstra.mode }}<br />
            ekskluderet skal være false: {{ !isExcluded(ekstra.ekskluder, $store.getters.bookingInProgress.wants) }}<br />
          </p>
          <p>Der er ingen ekstra tilkøb tilgængelige</p>
        </div> -->

      </div>

      <div v-if="findTotalAddons($store.getters.ekstras, wants, startdate) == 0">
          <!-- <p>{{ $t('errorNoAddons') }}</p> -->
        </div>


        
    </div>
</template>

<script>
import i18n from "@/plugins/i18n";
var moment = require('moment');

export default {
  name: "detailedEkstras",
  data() {
    return {
        name: "detailedExtras",
        editMode: [],
        antal_senge: [],
        antal_gaester: 0,
        antal_gaester_select: [],
        antal_naetter: 0,
        antal_naetter_select: [],
        total_morgenmad: 0,
        antal_gaester_per_room: {},
        detailedEkstras: {},
        totalNoChecked: 0,
        uniqueWants: [],
    }
  },
  props: {
    postnr: {},
    roomtype: {
      type: String,
      default: 'vaerelse'
    },
    cart: {
      type: String,
      default: 'addToCart'
    },
    startdate: {
      type: String,
      default: '9999-99-98'
    },
    enddate: {
      type: String,
      default: '9999-99-99'
    },
    rooms: {},
    wants: {}
  },
  created() {

      // ved split bookings fjerner denne evt. dublerede rooms fra listen over bestilte værelser
      this.uniqueWants = this.removeDuplicates(this.wants);

      this.getRoomData().then( () => {
      this.antal_naetter_select = this.makeSelectList(this.antalDage);  // Lav select listen til antal nætter
      this.antal_naetter = Math.max.apply(Math, this.antal_naetter_select); // Lad antal nætter defaulte til max antal i bestillingen
      this.antal_naetter_static = this.antal_naetter; // Sæt antal_naetter_static til valgte antal overnatninger, som vi ikke overskriver

      // Hent ekstra tilkøb fra API ved page load og...
      // Nulstil alle valg der foretages længere fremme i ordreprocessen, så der ikke ligger
      // gammel data og driller, hvis brugeren har trykket tilbage
      //console.log('Hotel postnr før get af ekstras: '+this.postnr)
      this.$store.dispatch("getEkstras", {
        'koncern': this.$route.params.koncern,
        'hotel': this.postnr,
        'la': i18n.locale,
        'type': this.roomtype
      }).then(() => {
        // Når vi har loadet 'ekstras' så nulstilles ekstras og brugeren videresendes hvis der ikke er nogen ekstra tilkøb tilgængelig
        this.nulstil(this.$store.getters.ekstras);
        if(typeof this.$store.getters.ekstras !== 'undefined' && this.countEkstras() <= 0) {
          console.log('Der er ingen ekstra tilkøb at vise...')
          //this.$router.replace({path: 'opsummering'});
        }

        // Sæt aktivt ekstra object til morgenmadsbestilling
        this.active_ekstra_object = this.findEkstraObject(this.$store.getters.ekstras, "Morg2");

        // byg this.detailedEkstras - afhænger af this.antal_senge og this.$store.getters.ekstras
        this.buildDetailedEkstras(this.$store.getters.ekstras, this.rooms).then(() => {
          this.buildDetailedEkstrasForSplit(this.$store.getters.ekstras).then(() => {
            // Vi er færdig med at skrive til vuex - emit tilbage til parent
            this.$emit('detailedEkstrasHasFinishedWritingToVuex', true);
          })
        })
        //this.buildDetailedEkstras(this.$store.getters.ekstras, this.$store.getters.tb_rooms)
      });

    }).catch(function (error) {
      console.log('Fejl i created: '+error)
    });

  },
  watch: {
  },
  computed: {
    // Beregner antal nætter der overnattes - denne skal rettes til så den beregner pr. room så vi kan give split rooms den rigtige varighed
    antalDage: function () {
      var start = new moment.utc(this.startdate);
      var end = new moment.utc(this.enddate);
      //var days = moment.duration(end.diff(start)).asDays()
      //console.log('detailedExtras: antal dage: '+days)
      return moment.duration(end.diff(start)).asDays()
      //return moment.duration(end.diff(start), 'days')
    },
  },
  methods: {
    /**
     * Find total amount of addons available
     * @param {Object}  ekstras
     * @param {Array}   wants
     * @param {String}  startdate
     */
    findTotalAddons(ekstras, wants, startdate) {
      var countAddons = 0;
      for (const [ekstra] of Object.entries(ekstras)) {
        //console.log(key+': '+JSON.stringify(ekstra));
        //console.log('Startdate: '+startdate)
        if(this.handleKarens(ekstra.karens, startdate) && ekstra.mode === 'detaljeret' && !this.isExcluded(ekstra.ekskluder, wants)) {
          countAddons++;
        }
      }

      //console.log('Addons totalt: '+countAddons);
      return countAddons;
    },
      /**
       * Returns true if 'wants' is not in 'excluded'
       * @param {string} excluded 
       * @param {int} wants 
       */
      isExcluded(excluded, wants) {
        //console.log('Result: '+excluded.split(',').includes(wants.toString()));
        //console.log('is '+wants+' excluded from: '+excluded);
        //console.log(excluded);

        if(excluded.split(',').includes(wants.toString())) {
          return true
        } else {
          return false
        }
    },
    /**
     * Find ud af hvor mange tilkøb der er valgt
     */
     totalEkstrasChecked(ekstras) {
      this.totalNoChecked = 0;  // Tæller der holder antal checked ekstras - startes med at initieres til 0
      for (const [ekstra] of Object.entries(ekstras)) {  // For hver ekstra tilkøb
        if(Object.hasOwn(this.detailedEkstras, ekstra.id_rec) && Object.keys(this.detailedEkstras).length > 0) {
          Object.values(this.detailedEkstras[ekstra.id_rec]).forEach(ekstraIterator => {
            if(ekstraIterator !== null) {
              if(ekstraIterator.checked == true) { // Room er Checked
                this.totalNoChecked++;  // Tæl en op
              } 
            }
          });
        }
      }
      //console.log('totalNoChecked i detailedExtras: '+this.totalNoChecked);

      // send totalNoChecked til parent component
      this.$emit('totalNoChecked', this.totalNoChecked);
    },    

    // Beregner totalprisen af valgte ekstra tilkøb
    totalPrice(ekstraId) {
      // Gemmer sum for hvert room
      var totalPrice = [];

      // Gå igennem tilkøb for hvert room og summér for hver valgt dato
      if(this.detailedEkstras[ekstraId] && this.detailedEkstras[ekstraId].length > 0) {
        this.detailedEkstras[ekstraId].forEach(ekstra => {
          if(ekstra !== null) {
            if(ekstra.checked == true) {  // Room er checked
              totalPrice[ekstra.room.id_room] = 0;
              console.log('totalPrice ekstra.days: '+JSON.stringify(ekstra.days));
              // Hvis der kun er 1 dato i ekstra.days indeholder den kun det ene objekt, er der flere er det et array af objekter
              if(ekstra.days.length > 0) {
                ekstra.days.forEach(day => {
                  if(day !== null && day.checked == true) {
                    // dato er checked - så den skal tælles med
                    //console.log('totalPRice: tæller en enkelt dato med - ekstra.room: '+ekstra.room.id_room+' ekstra.pris: '+ekstra.pris);
                    totalPrice[ekstra.room.id_room] += parseFloat(ekstra.pris);  // Læg priserne sammen for alle valgte dage - ekstra.pris er en string så den skal parses som en float
                  }
                })
              } else {
                  if(ekstra.days.date !== null && ekstra.days.checked == true) {
                    // dato er checked - så den skal tælles med
                    //console.log('totalPRice: tæller en enkelt dato med');
                    totalPrice[ekstra.room.id_room] += parseFloat(ekstra.pris);  // Læg priserne sammen for alle valgte dage - ekstra.pris er en string så den skal parses som en float
                  }
              }

              //console.log('Ekstra ID: '+ekstraId+' room: '+ekstra.room+' total price: '+totalPrice+' antal personer: '+ekstra.antal_personer);
              totalPrice[ekstra.room.id_room] = totalPrice[ekstra.room.id_room] * ekstra.antal_personer;  // Prisen ganges til sidst med valgte antal personer
            }
          }
        });
      }

      // Her tages totalprisen for hvert room og lægges sammen
      var sum = 0;
      totalPrice.forEach(price => {
        if(price !== null) {
          sum = sum+price;
        }
      })
    
    return sum;
    },
    // Justerer 'antal_naetter' i 'detailedEkstra' efter hvad der er checked af i detailedEkstras[ekstraId][room].days
    handleAntalNaetterChange(ekstraId,room) {
      var i = 0;
      this.detailedEkstras[ekstraId][room].days.forEach(day => {
        if(day.checked === true) {
          i++;
        }
        
      })
      this.detailedEkstras[ekstraId][room].antal_naetter = i;
      return i;
    },
        // bygger this.detailedEkstras og this.editMode
    buildDetailedEkstras(ekstras, rooms) {
      // Først skal arrayet initialiseres - bemærk - vi er nødt til at initialisere ved at bruge 'this.$set'-kald istedet for at modificere 'this.detailedEkstras' 
      // direkte, da Vue ellers ikke kan finde ud af at gøre detailedEkstras reaktiv
      //console.log('Bygger detailedEkstras med disse input data: '+JSON.stringify(ekstras));
      //console.log('builedDetailedEkstras: this.startdate: '+this.startdate+' this.antal_senge: '+JSON.stringify(this.antal_senge));
      ekstras.forEach(ekstra => {
        if(this.handleKarens(ekstra.karens, this.startdate) && ekstra.mode === 'detaljeret') {
          //console.log('Ekstra ID: '+ekstra.id_rec+' Ekstra Navn: '+ekstra.overskrift+' Tekst: '+ekstra.tekst+' Pris: '+ekstra.pris);
          this.$set(this.detailedEkstras, ekstra.id_rec, {});
          this.$set(this.editMode, ekstra.id_rec, {});
          rooms.forEach(room => {
            var roomId = room;
            //var roomId = room.id_room;
            //console.log('room: '+roomId+' stringify: '+JSON.stringify(room));
            this.$set(this.detailedEkstras[ekstra.id_rec], roomId, {});
            this.$set(this.editMode[ekstra.id_rec], roomId, {});
          });
        }
      });

      // vi skal bruge et array med datoer mellem start og slut
      var dates = this.getDaysRange(this.startdate, this.enddate);
      dates.forEach(function(part, index, dates) {
        dates[index] = {'date': moment(part).format('YYYY-MM-DD'), 'checked': true}
      });

      // Derefter looper vi igennem igen for at udfylde med data
      ekstras.forEach(ekstra => {
        if(this.handleKarens(ekstra.karens, this.startdate) && ekstra.mode === 'detaljeret') {
          rooms.forEach(room => {
            var roomId = room.id_room;

            //this.detailedEkstras[ekstra.id_rec][room] = {'checked': false, 'room': room, 'pris': ekstra.pris, 'antal_personer': this.antal_senge[room], 'antal_naetter': this.antalDage};

            // Her udfyldes detailedEkstras med data
            this.$set(this.editMode[ekstra.id_rec], roomId, false);

            // Her udfyldes detailedEkstras med data
            this.$set(this.detailedEkstras[ekstra.id_rec], roomId, {});
            this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'checked', false);
            this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'room', room);
            this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'pris', ekstra.pris);

            /**
             * For at dette virker med split rooms skal vi:
             *  - hvis room er split, fjerne de datoer der ikke bruges fra 'dates'
             *  - sætte this.antalDage (computed property) til det korrekte antal dage (1?)
             *  - hvis samme room er bestilt flere gange skal de merges da de ikke kan findes to gange på listen, da roomnr er key
             */

            // Hvis maxAntal er sat i kontrolpanelet, så sæt antal personer til dette tal, default er antal personer der er plads til på værelset
            if(ekstra.maxAntal > 0 && ekstra.maxAntal > this.antal_senge[roomId]) {
              //console.log('maxAntal: 1, id_rec: '+ekstra.id_rec);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer', this.antal_senge[roomId]);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer_max', this.antal_senge[roomId]);
            } else if(ekstra.maxAntal > 0 && ekstra.maxAntal <= this.antal_senge[roomId]) {
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer', ekstra.maxAntal);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer_max', ekstra.maxAntal);
              //console.log('maxAntal: 2, id_rec: '+ekstra.id_rec);
            } else {
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer', this.antal_senge[roomId]);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer_max', this.antal_senge[roomId]);
              //console.log('maxAntal: 3, id_rec: '+ekstra.id_rec+' antal senge: '+this.antal_senge[roomId]);
            }

            this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_naetter', this.antalDage);
            this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'days', JSON.parse(JSON.stringify(dates)));  // Vi bliver nødt til at sætte 'dates' ind på denne måde, da der ellers bliver indsat referencer til det samme objekt, som derfor ikke kan manipuleres individuelt

            // Hvis maxTotal er sat, sætter vi både antal personer og nætter til 1, og vælger den første nat som dato
            if(ekstra.maxTotal === '1') {
              //console.log('maxTotal er 1 på ekstra id: '+ekstra.id_rec);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_personer_max', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'antal_naetter', 1);
              this.$set(this.detailedEkstras[ekstra.id_rec][roomId], 'days', dates[0]);
            }
          });
        }
      });

      console.log('Siden er loaded, og detailedEkstras er seedes med disse data: '+JSON.stringify(this.detailedEkstras));

      // Opret kopi af detailedEkstras, som forbliver uændret
      //this.detailedEkstrasOriginal = JSON.parse(JSON.stringify(this.detailedEkstras));

      // afslut med at skrive ekstras objektet til axios store
      return this.handleDetailedEkstrasChange(this.detailedEkstras);

    },
      modifyDetailedEkstra(ekstrasDetailed, ekstraId, room, antal_personer, start, end) {

      // vi skal bruge et array med datoer mellem start og slut
      var dates = this.getDaysRange(start, end);
      dates.forEach(function(part, index, dates) {
        dates[index] = moment(part).format('YYYY-MM-DD')
      });
      
      for (var key in ekstrasDetailed) {
        if (ekstrasDetailed.hasOwnProperty(key)) {
          if (key == ekstraId) {
            // Hvis vi har fundet et ekstraId, og checkboxen er markeret for dette Id, så skriv ændringen
            if(this.detailedEkstras[ekstraId][room.id_room].checked == true) {
              //console.log('Skriver checked i ekstrasDetailed nu... (detailedExtras.vue)');
              ekstrasDetailed[ekstraId][room.id_room].checked = true;
            }
          }
        }
      }

      this.handleDetailedEkstrasChange(ekstrasDetailed);
      this.totalEkstrasChecked(this.$store.getters.ekstras);
    },
    /**
     * Lav et ekstra gennemløb af detailed ekstras, og ret alle split rooms så vi 
     * - merger hvis et room bliver booket flere gange
     * - retter start/slut datoer
     * - sætter korrekt antal dage
     */
    buildDetailedEkstrasForSplit(ekstras) {
      return new Promise((resolve) => {
        /**
         * Nedenstående løber igennem bookingInProgress.split og ekstras samt rooms og laver en datastruktur for split-rooms som 
         * passer med den vi bruger til normale ekstra tilkøb. Eksempel:
         * 
         * roomDatesMap["32"] = [
         *  { "date": "2024-11-06", "checked": true },
         *  { "date": "2024-11-07", "checked": true },
         *  { "date": "2024-11-08", "checked": true }
         * ];
         * 
         */
        Object.entries(this.$store.getters.bookingInProgress.split).forEach((eachRoomType) => {

          const roomDatesMap = {};

          eachRoomType.forEach(splitContents => {
            splitContents.forEach(splitContent => {
              if (!roomDatesMap[splitContent.room]) {
                roomDatesMap[splitContent.room] = [];
              }

              let dates = Array.isArray(splitContent.date) ? splitContent.date : [splitContent.date];
              let dateObjects = dates.map(date => ({
                date: date,
                checked: true
              }));

              roomDatesMap[splitContent.room] = roomDatesMap[splitContent.room].concat(dateObjects);
              
              ekstras.forEach(ekstra => {
                if(this.handleKarens(ekstra.karens, this.startdate) && ekstra.mode === 'detaljeret') {
                  //console.log('buildDetailedEkstrasForSplit: forEach ekstra: ekstra.id_rec: ' + JSON.stringify(ekstra.id_rec) + ' splitContent.room: ' + JSON.stringify(splitContent.room) + ' date(s): ' + JSON.stringify(roomDatesMap[splitContent.room]) + ' antal dage: '+roomDatesMap[splitContent.room].length);
                  this.$set(this.detailedEkstras[ekstra.id_rec][splitContent.room], 'antal_naetter', roomDatesMap[splitContent.room].length); // vi sætter antal dage midlertidigt til 1
                  this.$set(this.detailedEkstras[ekstra.id_rec][splitContent.room], 'days', JSON.parse(JSON.stringify(roomDatesMap[splitContent.room])));  // Vi bliver nødt til at sætte 'dates' ind på denne måde, da der ellers bliver indsat referencer til det samme objekt, som derfor ikke kan manipuleres individuelt
                }
              })
              



            })
          })
        });

        //console.log('Siden er loaded, og der er efterbehandlet for split rooms. detailedEkstras er seedet med disse data: '+JSON.stringify(this.detailedEkstras));
        resolve();
      })
    },
    /**
     * Fjerner dubletter i wants, som kan opstå når vi splitter rooms, hvor samme værelse
     * kan blive booket flere gange i samme booking.
     */
    removeDuplicates(wants) {
      // Convert all items to the same type, then use Set to remove duplicates
      wants = [...new Set(wants.map(item => Number(item)))];
      console.log('removeDuplicates: ' + JSON.stringify(wants));
      return wants;
    },
    // Returnerer liste med datoer der ligger imellem start/slut
    getDaysRange(startDate, endDate) {
      var dates = [];

      var currDate = moment(startDate).startOf('day');
      var lastDate = moment(endDate).startOf('day');

      while(currDate.add(1, 'days').diff(lastDate) < 1) {
          //console.log(currDate.toDate());
          dates.push(currDate.clone().toDate());
      }

      return dates;
    },
    // returnerer antal dage imellem to datoer
    findNrOfDays(startDate, endDate) {
      var start = moment(startDate);
      var end = moment(endDate);

      return end.diff(start, 'days');
    },
    // skriver det 'ekstra' objekt som morgenmads tilkøb bruger, så 'total_morgenmad'-watcheren kan få anvist et ekstra-object at skrive tilkøb til
    setActiveEkstraObject(ekstra) {
      this.active_ekstra_object = ekstra;
    },
    // returnerer det ekstra objekt der indeholder det angivne kortnavn
    findEkstraObject(ekstras, kortnavn) {
      for(var i=0; i<ekstras.length; i++) {
        if(ekstras[i].kortnavn == kortnavn) {
          //console.log('returnerer ekstras object: '+JSON.stringify(ekstras[i]));
          return ekstras[i];
        }
      }
    },
    // omdanner getteren tb_rooms til nyt array med id_room som key og antal_senge som value så morgenmadsvælgeren kan få max. antal gæster i opholdet
    getRoomData() {
      //console.log('Kører getRoomData()');
      // Hent tb_rooms indhold, bruges til at finde antal gæster der er plads til, til morgenmadsvælgeren
      return this.$store.dispatch("getTb_rooms", {'koncern': this.$route.params.koncern, postnr: this.postnr}).then(() => {
        //this.rooms = this.$store.getters.tb_rooms;
        const rooms = this.$store.getters.tb_rooms;
        // skriv nyt array
        this.antal_senge = [];
        for(var i=0; i<rooms.length; i++) {
          this.antal_senge[rooms[i]['id_room']] = rooms[i]['antal_senge'];
        }
      });
      
    },
    // Finder totalt antal senge der er valgt, for at sætte max. værdien i select listen til køb af morgenmad
    totalSengeThisOrder() {
      const rooms = this.$store.getters.bookingInProgress.wants;
      var totalSenge = 0;
      rooms.forEach(room => totalSenge = totalSenge + this.antal_senge[room])
      return totalSenge;
    },
    // skriver alle de værdier der skal være i select liste
    makeSelectList(max) {
      let selectList = [];
      for(var i = 1; i <= max; i++) {
        selectList.push(i);
      }

      return selectList;
    },
    modifyEkstraMorgenmad(bookingInProgress, ekstra, value) {
      // overskriver et ekstra tilkøb med nyt antal, bruges til morgenmads tilkøb
      //console.log('Kører addEkstraToOrder med value :'+value);
      this.addEkstraToOrder(bookingInProgress, ekstra, value)
    },
    // Nulstiller alle valg der foretages længere fremme i ordreprocessen, så der ikke ligger gammel data
    nulstil(ekstras) {
      var name = 'ekstras';
      var value = {};

      for (var key in ekstras) {
        if(ekstras.hasOwnProperty(key)) {
          // Ekstra køkkenhjælp for selskabslokale bliver sat til '1' som default
          if(ekstras[key].type == 'selskabslokale' && ekstras[key].kortnavn == 'koekkenhjaelp') {
            value[ekstras[key].id_rec] = 1;
          } else {
            value[ekstras[key].id_rec] = 0;
          }
        }
      }
      //console.log('Sætter '+name+': '+JSON.stringify(value) + ' nulstil()');
      this.$store.dispatch("addToCart", {name, value});
    },
    countEkstras() {
      var i = 0;
      
      for (var key in this.$store.getters.ekstras) {
        if(this.$store.getters.ekstras.hasOwnProperty(key)) {
          if(this.handleKarens(this.$store.getters.ekstras[key].karens, this.startdate)) {
            i++;
          }

        }
      }

      //console.log('ekstras count: '+i);
      return i;
    },
    // vurdér om karens gør at denne ekstra skal vises eller ej
    handleKarens(karens, startDate) {
      var start = new moment(startDate + ' 23:59:59');  // ankomst dagen
      var now = new moment();                                                   // nu
      if(moment.duration(start.diff(now)).asDays() > karens) {                 // hvis forskellen mellem nu og ankomstdagen er mere en der er sat i karens, så vis ekstratilkøbet
        //console.log('ACCEPT: diff:' + moment.duration(start.diff(now)).asDays() + ' karens:'+karens);
        return true;
      } else {
        //console.log('REJECT: diff:' + moment.duration(start.diff(now)).asDays() + ' karens:'+karens);
        return false;
      }

    },
    handleValgtStartDato(startdato) {
      var name = "startdate";
      var value = startdato;
      //console.log("Sætter " + name + ": " + value + ' handleValgtStartDato()');
      this.$store.dispatch("addToCart", { name, value }); // Gem startdato i Vuex store
      this.$router.push({ path: "slutdato" }); // Send brugeren videre til næste side
    },
    handleOrderChange(ekstras) {
        // Writes changes to the guests' order to the Vuex store
        var name = 'ekstras';
        var value = ekstras;
        //console.log('Sætter '+name+': '+JSON.stringify(value) + ' handleOrderChange()');
        this.$store.dispatch("addToCart", {name, value});
    },
    handleDetailedEkstrasChange(detailedEkstras) {
        // Skriver detaljeret ekstra tilkøb til Vuex store
        var name = 'detailedEkstras';
        var value = detailedEkstras;
        //var store = 'afterAddonData';
        // Her skal vi skrive til den Vuex store der er angivet i komponenten som en prop
        console.log('detailedExtras split-debug: Sætter '+name+': '+JSON.stringify(value, undefined, 4) + ' handleDetailedEkstrasChange() i addToAfterAddonCart, i cart: '+this.cart);
        return this.$store.dispatch(this.cart, {name, value});
    },


  }
}
</script>

<style>

.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
}

.roomBoxNew {
  display:flex;
  flex-direction: column;
  flex-wrap: nowrap;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 20px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 348px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 100px;
  margin-top: 100px;
  margin-left: 20px;
  margin-right: 20px;
}

.heading {
  font-size: 220%;
  margin-bottom: 0px;
  margin-top: -75px;
  height: 40px;
  text-overflow: ellipsis;
}

.descText {
  font-size: 120%;
  margin-top: 0px;
  height: 20px;
  text-transform: none;
}

.priceTextMorgenmad {
  font-size: 150%;
  margin-top: 60px;
  margin-bottom: 0px;
  margin-left: 30px;
  margin-right: 30px;
  text-transform: none;
  font-weight: bold;
}

/* Detaljeret ekstra-tilkøb Box-pr-værelseskategori */
.ekstraDetailedBox {
  background: rgba(0,64,114, 0.15); 
  padding-bottom: 5px; 
  padding-top: 1px; 
  padding-right: 5px; 
  margin-bottom: 15px;
  width: 315px;
}

/* Detaljeret ekstra-tilkøb Navn/titel på ekstratilkøb */
.ekstraDetailedName {
  text-align: center; 
  transform: scale(1.5);
}

/* Detaljeret ekstra-tilkøb sektion med prisdetaljer */
.ekstraDetailedDetails {
  text-align: right; 
  font-size: 75%; 
  line-height: 25%;
}

/* Detaljeret ekstra-tilkøb sektion med prisdetaljer, selve prisen */
.ekstraDetailedDetailsPrice {
  font-size: 150%;
}

.ekstra-default:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_default.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}
.ekstra-brev:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_brev.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-roedvin:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_roedvin.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-barneseng:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_barneseng.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-seng:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_seng.png");
  transform: scale(.5);
  margin-top: -150px;
  display: block;
}
.ekstra-madpakke:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_madpakke.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-madpakke-morgenmad:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_madpakke.png");
  transform: scale(.5);
  margin-top: -153px;
  display: block;
}
.ekstra-morgenmad:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_morgenmad.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-koekkenhjaelp:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_koekken.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
.ekstra-vandretur:before {
  content: url("https://bookingapi2.bbhotels.dk/storage/ekstra_vandretur.png");
  transform: scale(.5);
  margin-top: -120px;
  display: block;
}
</style>